import { createChart, IChartApi, MouseEventParams, LineData, CrosshairMode } from "./lcharts/src/api/create-chart";
import { DGDrawingServiceGlobal } from '../Services/DrawingService';
import { VectorCatcher } from "./lcharts/src/model/vector-catcher";
import { SerieColor } from "./LineSerie";


export class Chart {

  public chart: IChartApi;
  public chartTarget: HTMLElement

  constructor(chartTarget: HTMLElement) {
    this.chartTarget = chartTarget;
    this.initChart(this.chartTarget);
  }

  public destroyChart()
  {
    try
    {
      //this.chart.
      //this.chart.unsubscribeClick(this.handleClick);
      this.chart.remove();
      this.chart = null;
    }
    catch(e)
    {

    }
  }

  public refreshChart()
  {
    let w = this.chart.options().width;
    let h = this.chart.options().height;
    this.chart.resize(w,h,true);
  }

public initChart(chartTarget)
{
  this.chart = createChart(chartTarget, { width: chartTarget.offsetWidth,
    height: (chartTarget.offsetHeight),
    localization: {
      timeFormatter: function(businessDayOrTimestamp) {
          return 'X';
      },
  },
  });

    this.chart.applyOptions({
      layout: {
        backgroundColor: 'transparent',
        textColor: '#fff',
        fontSize: 12,
        fontFamily: 'Arial',
      },
      grid: {
        vertLines: {
          color: 'rgba(70, 130, 180, 0.5)',
          style: 1,
          visible: false,
        },
        horzLines: {
          color: 'rgba(70, 130, 180, 0.5)',
          style: 1,
          visible: false,
        },
      },
      crosshair: {
        mode: CrosshairMode.Normal
      },
      priceScale:{
        autoScale: false,
      }
    });
    this.chart.timeScale().applyOptions({
      rightOffset:10,
      borderVisible: false,
  });

  /*
  //for debug purposes only
  this.chart.applyOptions({
    grid: {
        vertLines: {
            color: 'rgba(70, 130, 180, 0.5)',
            style: 1,
            visible: true,
        },
        horzLines: {
            color: 'rgba(70, 130, 180, 0.5)',
            style: 1,
            visible: true,
        },
    },
});
*/

/*
- line = chart.addLine(LineData, lineOptions, paneIndex):SimpleLine

-- LineData - istnieje

 -- lineOption -
 color: string;
  lineStyle: LineStyle;
  lineWidth: LineWidth;
  extended - enum ExtendedType;

ExtendedType:
NoExtended - domyslne
ExtendedLeft - nieskonczony draw z lewej
ExtendedRight - nieskonczony draw z prawej
Infinity - extend w obie strony

----------------------------------------------
- removeLine(line)
---------------------------------------------
*/

this.chart.subscribeDoubleClick(function(param:MouseEventParams)
{



})


this.chart.subscribeClick(function(param:MouseEventParams)
{

    VectorCatcher.catchingOn();
    DGDrawingServiceGlobal.drawingService().chart.refreshChart();
    VectorCatcher.catchingOff();
    let nearest = VectorCatcher.findNearestVector(param.point.x,param.point.y);
    let res = VectorCatcher.findNearestVector(param.point.x,param.point.y)[0];

    if(nearest.length>1)
    {
      nearest.forEach((element)=>{
        //console.log(element);
        let timeID = VectorCatcher.getTimeIDfromID(element);
        let timeUTC =  DGDrawingServiceGlobal.drawingService().chart.chart.getDataLayer().getTimeFromIndex(timeID);
    //    //console.log("UTC time: " + timeUTC.timestamp);

        let serie = VectorCatcher.getSeriefromID(element);
        let model = DGDrawingServiceGlobal.drawingService().chart.chart.getChartModel();
        let activeSeries = model.getSeries();
        let selectedSerie = activeSeries.find(v=>{
          return v.serieIndex == serie.serieIndex
        });
        if((selectedSerie.options() as any).color!==SerieColor.DOWNZIGZAG && (selectedSerie.options() as any).color!==SerieColor.UPZIGZAG)
        {
          //console.log("1");
          res = element;
        }

      })
    }


    ////console.log("nearest vector = (" + res + ")");

    if (res!==-1)
    {
    //  VectorCatcher.logOutInfo(res);
      let timeID = VectorCatcher.getTimeIDfromID(res);
      let timeUTC =  DGDrawingServiceGlobal.drawingService().chart.chart.getDataLayer().getTimeFromIndex(timeID);
  //    //console.log("UTC time: " + timeUTC.timestamp);
      let serie = VectorCatcher.getSeriefromID(res);
      let findedSerieIndex = serie.serieIndex;


      let model = DGDrawingServiceGlobal.drawingService().chart.chart.getChartModel();
      let activeSeries = model.getSeries();

      let selectedSerie = activeSeries.find(v=>{
        return v.serieIndex == findedSerieIndex
      })

    if(selectedSerie && selectedSerie.getPaneID()==0)

      DGDrawingServiceGlobal.drawingService().activeRetracements.activeNewRetracementIndicator(findedSerieIndex, timeUTC.timestamp);
      VectorCatcher.clean();
      return;

    }

    VectorCatcher.clean();

    DGDrawingServiceGlobal.drawingService().activeRetracements.retracementsMenu.searchClickedRetracement(param);
    //DGDrawingServiceGlobal.drawingService().annotations.clickAction(param);



})

}
}

export interface ISerieMap
{
  data:LineData[],
  serie: any
}
